export default class CustomerDynamicCounterBlock {
    constructor() {
        this.counterObserver()
    }

    static counterAnimation(counterBlockId) {
        const $counterSelector = $(`#customer-block-id-${counterBlockId}`)
        const $number = $(`#customer-block-id-${counterBlockId}.is-visible .js-number`)
        const duration = Number.parseInt($counterSelector.data('cx-counter-duration')) * 1000

        $number.each(function () {
            const size = $(this).text().toLocaleString().split('.')[1]
                ? $(this).text().toLocaleString().split('.')[1].length
                : 0
            $(this)
                .prop('Counter', 0)
                .animate(
                    {
                        Counter: $(this).text(),
                    },
                    {
                        duration: duration,
                        step: function (func) {
                            $(this).text(Number.parseFloat(func).toFixed(size))
                        },
                    },
                )
        })
    }

    counterObserver() {
        const ratio = 0.3
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.3,
        }

        const handleIntersect = (entries, observer) => {
            entries.forEach((entry) => {
                const counterBlockId = entry.target.dataset.customerCounterBlockId

                if (entry.intersectionRatio >= ratio) {
                    entry.target.classList.add('is-visible')
                    CustomerDynamicCounterBlock.counterAnimation(counterBlockId)
                    observer.unobserve(entry.target)
                }
            })
        }

        const observer = new IntersectionObserver(handleIntersect, options)
        document.querySelectorAll('.js-dynamic-counters').forEach((el) => {
            observer.observe(el)
        })
    }
}

new CustomerDynamicCounterBlock()
